// extracted by mini-css-extract-plugin
export default {"btn":"ButtonGameState_btn__av+mM","icon":"ButtonGameState_icon__S0RDW"};